import { render } from "./PayOutCompletedDealsCheckDescription.vue?vue&type=template&id=74f3c217&ts=true"
import script from "./PayOutCompletedDealsCheckDescription.vue?vue&type=script&lang=ts"
export * from "./PayOutCompletedDealsCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__